import { z } from "zod";

/**
 * 修改密碼表單的前端檢查。
 *
 * 只檢查「有填」與「兩次一致」，**刻意不寫任何強度規則**：業主決定不設
 * 密碼強度（見 apps/api/config/settings/base.py 的 `AUTH_PASSWORD_VALIDATORS`），
 * 那份清單是唯一的開關。前端再寫一份長度或字元規則，後端哪天加回規則時兩邊
 * 就不一致了；強度不足一律以後端 `validate_password` 回的訊息為準，顯示在
 * 新密碼欄位下。
 *
 * 「目前密碼對不對」也只有後端知道，同樣由伺服器的欄位錯誤標在欄位上。
 */
export const changePasswordSchema = z
  .object({
    current_password: z.string().min(1, "請輸入目前密碼"),
    new_password: z.string().min(1, "請輸入新密碼"),
    confirm_password: z.string().min(1, "請再輸入一次新密碼"),
  })
  .refine((values) => values.new_password === values.confirm_password, {
    path: ["confirm_password"],
    message: "兩次輸入的新密碼不一致",
  });

export type ChangePasswordValues = z.infer<typeof changePasswordSchema>;
